import React from 'react';
import { Box, Typography, Paper, IconButton } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

const PALETTE_NODES = [
  { type: 'prompt', label: 'Prompt', icon: '◈', color: '#4a7aaa', description: 'Base / Global / Vendor / Region' },
  { type: 'execution_rules', label: 'Execution Rules', icon: '⚡', color: '#aa5a3a', description: 'Pre-filled from template' },
  { type: 'knowledge_management', label: 'Knowledge Mgmt', icon: '📖', color: '#3a8a5a', description: 'Pre-filled from template' },
  { type: 'intelligence_guidelines', label: 'Guidelines', icon: '🧠', color: '#3a6aaa', description: 'Pre-filled from template' },
  { type: 'forms', label: 'Forms', icon: '⊟', color: '#6a8a2a', description: 'Form & quick reply protocol' },
  { type: 'settings', label: 'Settings', icon: '⚙', color: '#8a5aaa', description: 'Agent config' },
  { type: 'data_schema', label: 'Data Schema', icon: '⊞', color: '#5aaa7a', description: 'Initial fields' },
  { type: 'global_tools', label: 'Available Tools', icon: '⊕', color: '#0891b2', description: 'Tools not in prompt' },
];

export default function NodePalette({ collapsed = false, onToggle }) {
  if (collapsed) {
    return (
      <Box sx={{ width: 28, flexShrink: 0, borderLeft: '1px solid', borderColor: 'divider', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', pt: 0.5 }}>
        <IconButton size="small" onClick={onToggle} title="Show node palette">
          <ChevronLeftIcon fontSize="small" />
        </IconButton>
      </Box>
    );
  }

  return (
    <Box sx={{ width: 180, flexShrink: 0, borderLeft: '1px solid', borderColor: 'divider', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <Box sx={{ px: 1.5, py: 0.75, borderBottom: '1px solid', borderColor: 'divider', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="overline" sx={{ color: 'text.secondary', fontSize: 10, letterSpacing: 1 }}>Nodes</Typography>
        <IconButton size="small" onClick={onToggle} title="Hide node palette">
          <ChevronRightIcon fontSize="small" />
        </IconButton>
      </Box>
      <Box sx={{ flex: 1, overflowY: 'auto', p: 1.5 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {PALETTE_NODES.map((item) => (
            <Paper
              key={item.type}
              variant="outlined"
              sx={{ p: 1, cursor: 'grab', borderColor: item.color, '&:hover': { bgcolor: 'action.hover' }, display: 'flex', alignItems: 'center', gap: 1 }}
              draggable
              onDragStart={(e) => e.dataTransfer.setData('nodeType', item.type)}
            >
              <Typography sx={{ color: item.color, fontSize: 16 }}>{item.icon}</Typography>
              <Box>
                <Typography variant="body2" sx={{ fontWeight: 'bold', fontSize: 11 }}>{item.label}</Typography>
                <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: 9 }}>{item.description}</Typography>
              </Box>
            </Paper>
          ))}
        </Box>
        <Box sx={{ mt: 2, pt: 2, borderTop: '1px solid', borderColor: 'divider' }}>
          <Typography variant="overline" sx={{ color: 'text.disabled', fontSize: 9, letterSpacing: 1 }}>Via prompt</Typography>
          <Paper variant="outlined" sx={{ mt: 0.5, p: 1, borderStyle: 'dashed', opacity: 0.6 }}>
            <Typography variant="caption" sx={{ color: 'text.disabled' }}>
              <strong style={{ color: '#22c55e' }}>$class.method</strong> — tool call
            </Typography>
          </Paper>
          <Paper variant="outlined" sx={{ mt: 0.5, p: 1, borderStyle: 'dashed', opacity: 0.6 }}>
            <Typography variant="caption" sx={{ color: 'text.disabled' }}>
              <strong style={{ color: '#a855f7' }}>@Agent</strong> — sub-agent
            </Typography>
          </Paper>
        </Box>
      </Box>
    </Box>
  );
}
